import React, { useEffect, useState } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import api from '../api/axios';
// import Cookies from 'js-cookie';


const AdminPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(false);
    const [user, setUser] = useState({ UserID: '', DisplayName: '' });
    const [dropdownOpen, setDropdownOpen] = useState(false);


    const [companyList, setCompanyList] = useState([]);
    const [selectedCID, setSelectedCID] = useState(localStorage.getItem('cid') || '');

    useEffect(() => {
        const fetchCompanies = async () => {
            try {
                // const token = Cookies.get('token');
                const token = localStorage.getItem('token')
                const res = await api.get('/cred/cidavailable', {
                    headers: { authorization: token },
                });
                setCompanyList(res.data.data);
            } catch (error) {
                console.error('Error fetching companies:', error);
            }
        };
        fetchCompanies();
    }, []);



    const routeTitle = {
        '/admin/dashboard': 'Dashboard',
        '/admin/users': 'Users',
        '/admin/reports': 'Reports',
        '/admin/monthlyclosing': 'Monthly Closing',
        '/admin/userprofile': 'UserProfile',
    }[location.pathname] || 'Admin';
    useEffect(() => {
        const handleClickOutside = (event) => {
            const dropdown = document.getElementById('userDropdown');
            if (dropdown && !dropdown.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        if (dropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [dropdownOpen]);

    useEffect(() => {
        // const token = Cookies.get('token');
        const token = localStorage.getItem('token')
        if (!token) return navigate('/');

        try {
            const decoded = jwtDecode(token);
            const { exp, UserID, DisplayName } = decoded;
            if (Date.now() >= exp * 1000) {
                // Cookies.remove('token');
                localStorage.removeItem('token')
                navigate('/');
            } else {
                setUser({ UserID, DisplayName });
            }
        } catch {
            // Cookies.remove('token');
            localStorage.removeItem('token')
            navigate('/');
        }

        if (collapsed) {
            const tooltips = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
            tooltips.forEach((el) => new window.bootstrap.Tooltip(el));
        }
    }, [collapsed, navigate]);

    const toggleSidebar = () => setCollapsed(!collapsed);
    const handleCIDChange = (e) => {
        console.log('Selected CID:', e.target);
        const selectedCid = e.target.value;
        setSelectedCID(selectedCid);
        localStorage.setItem('cid', selectedCid);
        // Optionally trigger a reload or notify context/store
    };

    const handleSidebarClose = () => {
        const sidebar = document.getElementById('sidebarMenu');
        const offcanvas = window.bootstrap?.Offcanvas.getInstance(sidebar);
        if (offcanvas) offcanvas.hide();
    };

    return (
        <>
            {/* Fixed Navbar */}
            <nav
                className="navbar navbar-dark bg-dark fixed-top d-flex align-items-center px-3"
                style={{ height: '56px', zIndex: 1040 }}
            >
                <button
                    className="btn btn-light me-2 d-md-none"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#sidebarMenu"
                >
                    <i className="fas fa-bars"></i>
                </button>
                <div style={{
                    marginRight: 10,
                    height: 40,
                    width: 40,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'white', // optional: helps the border stand out
                }}>
                    <img src="/logo192.png" alt="Logo"
                        style={{ height: 28, width: 28 }} />
                </div>
                <span className="navbar-brand mb-0">IMA-FE</span>
                <div className="ms-auto d-flex">

                    <div className="d-flex align-items-center gap-3">

                        <div className="ms-auto d-flex align-items-center gap-3">

                            <select
                                className="form-select form-select-sm border-0 rounded-pill px-3 shadow-sm"
                                style={{
                                    backgroundColor: 'white',
                                    fontSize: '0.85rem',
                                    height: '32px',
                                }}
                                value={selectedCID}
                                onChange={handleCIDChange}
                            >
                                {/* <option value="">-- Select Your Cluster --</option> */}
                                {companyList.map((company) => (
                                    <option key={company.cid} value={company.cid}>
                                        {company.CompanyName} | {company.cidname}
                                    </option>
                                ))}
                            </select>




                            <div className="position-relative">

                                <button
                                    className="btn d-flex align-items-center gap-3 px-1 py-1 border-0 bg-white shadow-sm rounded-pill pe-2 "
                                    type="button"
                                    onClick={() => setDropdownOpen((prev) => !prev)}
                                    style={{
                                        transition: 'all 0.2s ease-in-out',
                                        fontSize: '0.85rem',
                                        lineHeight: '1',
                                    }}
                                >
                                    <img
                                        src={`https://ui-avatars.com/api/?name=${user.DisplayName}&background=0D8ABC&color=fff&size=28`}
                                        alt="avatar"
                                        className="rounded-circle"
                                        width="28"
                                        height="28"
                                    />
                                    <span className="text-dark fw-medium d-none d-sm-inline">{user.DisplayName}</span>
                                    <i className={`fas fa-chevron-${dropdownOpen ? 'up' : 'down'} text-muted`}></i>
                                </button>


                                {dropdownOpen && (
                                    <ul
                                        className="dropdown-menu dropdown-menu-end show"
                                        style={{
                                            position: 'absolute',
                                            top: '100%',
                                            right: 0,
                                            zIndex: 1050,
                                        }}
                                    >
                                        <li>
                                            <button
                                                className="dropdown-item"
                                                onClick={() => {
                                                    setDropdownOpen(false);
                                                    navigate('/admin/userprofile');
                                                }}
                                            >
                                                <i className="fas fa-user me-2"></i> Profile
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                className="dropdown-item"
                                                onClick={() => {
                                                    setDropdownOpen(false);
                                                    // Cookies.remove('token');
                                                    localStorage.removeItem('token')
                                                    navigate('/');
                                                }}
                                            >
                                                <i className="fas fa-sign-out-alt me-2"></i> Logout
                                            </button>
                                        </li>
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>




                </div>
            </nav>

            <div className="container-fluid " style={{ paddingTop: '56px' }}>
                <div className="row flex-nowrap" >
                    {/* Sidebar */}
                    <div
                        className={`offcanvas-md offcanvas-start bg-light border-end p-0 d-md-block`}
                        tabIndex="-1"
                        id="sidebarMenu"
                        style={{
                            width: collapsed ? '60px' : '250px',
                            maxWidth: collapsed ? '60px' : '250px',   // ✅ Add this
                            overflowX: 'hidden',                      // ✅ Add this
                            position: 'fixed',
                            top: '56px',
                            height: 'calc(100vh - 56px)',
                            zIndex: 1030,
                        }}
                    >
                        <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
                            <span className="fw-bold">{!collapsed ? routeTitle : ''}</span>
                            <div>
                                <button
                                    className="btn d-none d-md-inline btn-light"
                                    onClick={toggleSidebar}
                                >
                                    <i className={`fas ${collapsed ? 'fa-chevron-right' : 'fa-chevron-left'}`}></i>
                                </button>
                                <button
                                    type="button"
                                    className="btn-close d-md-none"
                                    data-bs-dismiss="offcanvas"
                                ></button>
                            </div>
                        </div>

                        {/* SIDEBAR MENU */}
                        <ul className="nav flex-column px-2 pt-3">
                            {[
                                { to: 'dashboard', icon: 'fa-home', label: 'Dashboard' },
                                { to: 'monthlyclosing', icon: 'fa-warehouse', label: 'Monthly Closing' },
                                // { to: 'users', icon: 'fa-users', label: 'Users' },
                                { to: 'reports', icon: 'fa-chart-bar', label: 'Consolidation Reports' },
                            ].map(({ to, icon, label }) => (
                                <li className="nav-item" key={to}>
                                    <NavLink
                                        to={to}
                                        className={({ isActive }) =>
                                            `nav-link d-flex align-items-center 
                                            rounded px-2 py-2 transition 
                                            overflow-hidden w-100 
                                            ${isActive ? 'bg-dark text-white fw-semibold shadow-sm'
                                                : 'text-dark hover-bg'
                                            }`
                                        }
                                        style={{ whiteSpace: 'nowrap' }}
                                        onClick={handleSidebarClose}
                                        title={collapsed ? label : ''}
                                    >
                                        <i className={`fas ${icon} me-0`} 
                                        style={{ height: 16, width: 16 }}></i>
                                        {!collapsed && <span className="ms-3">{label}</span>}
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Main Content */}
                    <main className={`col p-4`}>
                        <div
                            style={{

                                paddingLeft: collapsed ? '60px' : '250px',
                                paddingRight: '15px',
                            }}
                        >
                            <Outlet />
                        </div>
                    </main>
                </div>
            </div>
        </>
    );
};

export default AdminPage;
